import React from "react";

const Trabajador = () => {
	return <div>Trabajador</div>;
};

export default Trabajador;
